import React, { Component } from 'react';
import { NumberInput, FormWithChildren, TextInput } from 'library';


export default class HealthBlock extends React.Component {
    render (){
        var instance = this.props.instance;
        var monster = this.props.monster;

        var is_not_player = monster.hit_dice.indexOf('d') != -1 || !(monster.hit_points);
        var max_health = [
            <div>Hit Point Maximum </div>,
            <FormWithChildren className='hp-max' setGlobalState={this.props.update_monster} autoSetGlobalState={true} globalStateName={'health'} defaults={monster} >
                <NumberInput sneaky_input={true} name={'hit_points'} style={{textAlign:'center'}} />
            </FormWithChildren>
        ];
        if (is_not_player){
            max_health = [
                <div>Hit Dice (Dice Only) </div>,
                <FormWithChildren className='hp-max' setGlobalState={this.props.update_monster} autoSetGlobalState={true} globalStateName={'health'} defaults={monster} >
                    <TextInput sneaky_input={true} name={'hit_dice'} style={{textAlign:'center'}} />
                </FormWithChildren>,
            ];
        }

        return (
            <div>
                <div className='hp' >
                    <div style={{padding:'1% 10%'}} >
                        {max_health}
                        <FormWithChildren className='hp-current' setGlobalState={this.props.update_instance} autoSetGlobalState={true} globalStateName={'health'} defaults={instance} >
                            <NumberInput sneaky_input={true} name={'current_hp'} style={{textAlign:'center'}} />
                        </FormWithChildren>
                    </div>
                    <div className='bottom-label'>CURRENT HIT POINTS</div>
                </div>
                <div className='temp-hp' >
                    <FormWithChildren className='hp-temp' setGlobalState={this.props.update_instance} autoSetGlobalState={true} globalStateName={'health'} defaults={instance} >
                        <NumberInput sneaky_input={true} name={'temp_hp'} style={{textAlign:'center'}} />
                    </FormWithChildren>
                    <div className='bottom-label'>TEMP HIT POINTS</div>
                </div>
            </div>
        );
    }
}
